var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0005 11.667C23.7212 11.667 20.2422 15.146 20.2422 19.4253C20.2422 23.623 23.5252 27.0203 27.8045 27.1673C27.9352 27.151 28.0659 27.151 28.1639 27.1673C28.1965 27.1673 28.2129 27.1673 28.2455 27.1673C28.2619 27.1673 28.2619 27.1673 28.2782 27.1673C32.4595 27.0203 35.7425 23.623 35.7589 19.4253C35.7589 15.146 32.2799 11.667 28.0005 11.667Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.298 31.5119C31.741 28.4739 24.3093 28.4739 19.7196 31.5119C17.6453 32.9002 16.502 34.7786 16.502 36.7876C16.502 38.7966 17.6453 40.6586 19.7033 42.0306C21.99 43.5659 24.9953 44.3336 28.0006 44.3336C31.006 44.3336 34.0113 43.5659 36.298 42.0306C38.356 40.6422 39.4993 38.7802 39.4993 36.7549C39.483 34.7459 38.356 32.8839 36.298 31.5119Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.0e60528ac2a73f8cfac062c548ce6b79.svg";
export { ForwardRef as ReactComponent };